import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EventState {
  eventId: string | null;
}

export const initialEventState: EventState = { eventId: null };

const eventSlice = createSlice({
  name: 'event',
  initialState: initialEventState,
  reducers: {
    upsertEvent(state, action: PayloadAction<{ eventId: string }>) {
      const c = action.payload;
      state.eventId = action.payload.eventId;
    },
    clearEvent() {
      return initialEventState;
    },
  },
});

export const { upsertEvent, clearEvent } = eventSlice.actions;
export default eventSlice.reducer;
